module.exports = __webpack_public_path__ + "img/DE03956.df6cf0cc.png";